import React from "react";
import ReactDOM from "react-dom/client";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "@/App";
import { ApiError } from "@/lib/api";
import { queryKeys } from "@/lib/queries";
import { ThemeProvider } from "@/lib/theme";
import { TimezoneProvider } from "@/lib/timezone";
import "@/locales/i18n";
import "driver.js/dist/driver.css";
import "@/styles.css";

function invalidateSessionAfterUnauthorized(error: unknown, queryKey?: readonly unknown[]) {
  if (!(error instanceof ApiError) || error.status !== 401) return;
  if (queryKey?.[0] === queryKeys.identity[0] && queryKey?.[1] === queryKeys.identity[1]) return;
  void queryClient.invalidateQueries({ queryKey: queryKeys.identity });
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: (error, query) => invalidateSessionAfterUnauthorized(error, query.queryKey) }),
  mutationCache: new MutationCache({ onError: (error) => invalidateSessionAfterUnauthorized(error) }),
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TimezoneProvider>
          <App />
        </TimezoneProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
